//imports
import {
    CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL,
    CANNEDCOMMAND_CREATE_REQUEST,
    CANNEDCOMMAND_CREATE_RESULT,
    CANNEDCOMMAND_UPDATE_REQUEST,
    CANNEDCOMMAND_UPDATE_RESULT,
    CANNEDCOMMAND_GET_REQUEST,
    CANNEDCOMMAND_GET_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    cannedCommand: null,
    current: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case CANNEDCOMMAND_CREATE_REQUEST:
            return { ...state, loading: true }

        case CANNEDCOMMAND_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case CANNEDCOMMAND_UPDATE_REQUEST:
            return { ...state, loading: true }

        case CANNEDCOMMAND_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CANNEDCOMMAND_GET_REQUEST:
            return { ...state, loading: true }

        case CANNEDCOMMAND_GET_RESULT:
            return { ...state, loading: false, cannedCommand: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_CANNEDCOMMAND"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
